import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { DiagnosticsColumnDefinitions } from './columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { alignCenterCellStyle } from '@common/cellStyles';

const periodColumnDefinition = {
  headerName: 'Period',
  field: 'periodName',
  width: 120,
  ...alignCenterCellStyle,
};

export default ({
  diagnostics,
  periodName,
  connName,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => {
  diagnostics.paymentsAndTransfers.forEach(
    paymentsAndTransfer => paymentsAndTransfer.periodName = periodName
  );
  diagnostics.nonZeroBalances.forEach(
    nonZeroBalance => nonZeroBalance.periodName = periodName
  );
  diagnostics.nonMatchingBalances.forEach(
    nonMatchingBalance => nonMatchingBalance.periodName = periodName
  );
  diagnostics.nonMatchingBalancesSupport.forEach(
    nonMatchingBalanceSupport => nonMatchingBalanceSupport.periodName = periodName
  );

  xlsxExport({
    sheetData: [
      {
        name: 'Payments and Transfers',
        columnDefinitions: [periodColumnDefinition].concat(
          DiagnosticsColumnDefinitions.paymentsAndTransfersColumns
        ),
        data: diagnostics.paymentsAndTransfers,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Non Zero Balances',
        columnDefinitions: [periodColumnDefinition].concat(
          DiagnosticsColumnDefinitions.nonZeroBalancesColumns
        ),
        data: diagnostics.nonZeroBalances,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Non Matching Balances',
        columnDefinitions: [periodColumnDefinition].concat(
          DiagnosticsColumnDefinitions.nonMatchingBalancesColumns
        ),
        data: diagnostics.nonMatchingBalances,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Non Matching Balances Support',
        columnDefinitions: [periodColumnDefinition].concat(
          DiagnosticsColumnDefinitions.nonMatchingBalancesSupportColumns
        ),
        data: diagnostics.nonMatchingBalancesSupport,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
    ],
    metadata: {
      disableHeaderRendering: true,
      fileName: `TLS_Diagnostics_${periodName}_${connName}${environmentSuffix}`,
    },
  });
};
